var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdeaGradient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0118 0C11.0045 0 10.9978 0 10.9912 0C9.13667 0 7.39143 0.738311 6.0766 2.08069C4.7566 3.4276 4.02942 5.2172 4.02942 7.12217C4.02942 8.87783 4.66284 10.5633 5.81378 11.865C6.52767 12.6735 6.92043 13.7496 6.92043 14.8967C6.92043 15.8145 7.46304 16.6033 8.236 16.9532V17.5566C8.236 18.9035 9.30868 20 10.6272 20H11.3743C12.6928 20 13.7655 18.9035 13.7655 17.5566V16.9532C14.5385 16.6033 15.0811 15.8145 15.0811 14.8967C15.0811 13.7496 15.4739 12.6742 16.1877 11.865C17.3387 10.5626 17.9721 8.87783 17.9721 7.12217C17.9721 5.21795 17.2449 3.42836 15.9249 2.08069C14.6086 0.739065 12.8634 0 11.0118 0ZM11.3736 18.6418H10.6265C10.041 18.6418 9.56486 18.1546 9.56486 17.5566V17.1478H12.4359V17.5566C12.4352 18.1546 11.959 18.6418 11.3736 18.6418ZM15.2007 10.9563C14.2653 12.0136 13.7508 13.4133 13.7508 14.8967C13.7508 15.3891 13.3587 15.7903 12.8759 15.7903H9.12264C8.64056 15.7903 8.24781 15.3899 8.24781 14.8967C8.24781 13.4133 7.73324 12.0143 6.79788 10.9563C5.86841 9.90347 5.3568 8.54223 5.3568 7.12217C5.3568 5.58069 5.94519 4.13198 7.01345 3.04148C8.07801 1.95626 9.48955 1.35897 10.9919 1.35897C10.9993 1.35973 11.0045 1.35973 11.0081 1.35897C12.5075 1.35897 13.9191 1.95626 14.9844 3.04148C16.0526 4.13198 16.641 5.58069 16.641 7.12217C16.6425 8.54148 16.1302 9.90271 15.2007 10.9563Z",
    fill: "url(#paint0_linear_69_138)",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90588 2.77933C8.47809 3.15414 7.30279 4.27556 6.83621 5.70769C6.72104 6.06364 6.9093 6.44751 7.25702 6.56666C7.32715 6.59004 7.39728 6.60135 7.46668 6.60135C7.745 6.60135 8.00487 6.42111 8.09715 6.1368C8.42124 5.1383 9.24145 4.35625 10.2351 4.09532C10.5902 4.0018 10.8043 3.63227 10.7135 3.26877C10.6227 2.90527 10.261 2.69185 9.90588 2.77933Z",
    fill: "url(#paint1_linear_69_138)",
    fillOpacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.23073 2.55288C1.92731 2.34021 1.51388 2.4209 1.30717 2.7301C1.10046 3.0393 1.17798 3.46163 1.48066 3.67354L2.47731 4.36962C2.59174 4.44956 2.72241 4.48802 2.8516 4.48802C3.06348 4.48802 3.27167 4.38395 3.40086 4.19164C3.60758 3.88244 3.53006 3.46012 3.22737 3.2482L2.23073 2.55288Z",
    fill: "url(#paint2_linear_69_138)",
    fillOpacity: 0.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.52126 7.25454C2.52126 6.87973 2.22375 6.57581 1.85683 6.57581H0.664552C0.297639 6.57581 0.00012207 6.87973 0.00012207 7.25454C0.00012207 7.62935 0.297639 7.93327 0.664552 7.93327H1.8561C2.22301 7.93403 2.52126 7.62935 2.52126 7.25454Z",
    fill: "url(#paint3_linear_69_138)",
    fillOpacity: 0.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.47763 10.1395L1.48099 10.8348C1.1783 11.046 1.10005 11.4691 1.3075 11.7783C1.43595 11.9706 1.64488 12.0747 1.85676 12.0747C1.98595 12.0747 2.11662 12.0362 2.23105 11.9563L3.2277 11.2609C3.53038 11.0498 3.60864 10.6267 3.40119 10.3175C3.19374 10.0083 2.78031 9.92609 2.47763 10.1395Z",
    fill: "url(#paint4_linear_69_138)",
    fillOpacity: 0.9
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1481 4.48835C19.2773 4.48835 19.408 4.44989 19.5224 4.36995L20.5191 3.67387C20.8218 3.46196 20.9 3.03964 20.6926 2.73044C20.4851 2.42123 20.0717 2.33979 19.769 2.55321L18.7724 3.24929C18.4697 3.4612 18.3914 3.88353 18.5989 4.19273C18.7281 4.38503 18.9363 4.48835 19.1481 4.48835Z",
    fill: "url(#paint5_linear_69_138)",
    fillOpacity: 0.9
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3357 6.57581H20.1442C19.7773 6.57581 19.4797 6.87973 19.4797 7.25454C19.4797 7.62935 19.7773 7.93327 20.1442 7.93327H21.3357C21.7026 7.93327 22.0001 7.62935 22.0001 7.25454C22.0001 6.87973 21.7026 6.57581 21.3357 6.57581Z",
    fill: "url(#paint6_linear_69_138)",
    fillOpacity: 0.9
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5221 10.1394C19.2194 9.92676 18.8045 10.0075 18.5986 10.3167C18.3918 10.6259 18.4694 11.0489 18.772 11.2601L19.7687 11.9554C19.8831 12.0354 20.0138 12.0738 20.143 12.0738C20.3549 12.0738 20.5638 11.9697 20.6922 11.7774C20.899 11.4682 20.8214 11.0452 20.5188 10.834L19.5221 10.1394Z",
    fill: "url(#paint7_linear_69_138)",
    fillOpacity: 0.9
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_69_138",
    x1: 12.2683,
    y1: 10.5,
    x2: 9.22464,
    y2: 19.3921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#347B7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_69_138",
    x1: 9.12583,
    y1: 4.7766,
    x2: 8.70393,
    y2: 6.58633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#347B7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_69_138",
    x1: 2.5654,
    y1: 3.51234,
    x2: 2.35949,
    y2: 4.48918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#347B7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_69_138",
    x1: 1.48989,
    y1: 7.28848,
    x2: 1.40467,
    y2: 7.95177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#347B7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_69_138",
    x1: 2.56578,
    y1: 11.0989,
    x2: 2.35991,
    y2: 12.0758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#347B7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_69_138",
    x1: 19.8572,
    y1: 3.51252,
    x2: 19.6512,
    y2: 4.48952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#347B7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_69_138",
    x1: 20.9691,
    y1: 7.28848,
    x2: 20.8838,
    y2: 7.95176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#347B7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_69_138",
    x1: 19.8568,
    y1: 11.0985,
    x2: 19.651,
    y2: 12.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#347B7D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaGradient);
export default __webpack_public_path__ + "static/media/idea-gradient.09cbd96efaf0d4f4907dc703a2aa2431.svg";
export { ForwardRef as ReactComponent };